import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "HMSA (Hawaii Medical Service Association)",
  shortName: "HMSA",
  slug: "hmsa-insurance",
  seoTitle: "HMSA TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how HMSA policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "HMSA TMS coverage, HMSA SPRAVATO authorization, HMSA mental health benefits Coral Springs FL, HMSA depression treatment Florida",
};

export const HmsaInsurance = () => <InsurancePageTemplate config={config} />;
export default HmsaInsurance;
